import axios from 'axios';
import ServerProperties from '../../config/server.js'

export default {
  Register: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer " + params.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API+'Import/',
      params.data.Data,
      {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      params.onsuccess(params, response)
    })
    .catch(function (error) {
      console.log(error)
      params.onfailed(params, error.response)
    });
  },
  ReadAsMaster(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API + params.data.query)
    .then(function (response) {
        params.onsuccess(params, response);
    })
    .catch(error => {            
        params.onfailed(params, error.response)
    });
  }
}


// WEBPACK FOOTER //
// ./src/App/master/import/model.js